import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import moment from 'moment';
import {
  Global,
} from '../model';
import {
  PLANNER_OVER_ORDERS_PHASE,
  PLANNER_OUT_ORDERS_PHASE,
  PLANNER_SHOW_ORDERS_PHASE_TT,
  PLANNER_HIDE_ORDERS_PHASE_TT,
  PLANNER_CLICK_UNDER,
  PLANNER_CLICK_STATUS,
  PLANNER_CLICK_PIN
} from 'apps/events';
import { LineOverOrdersPhase } from '../model';
import PlannerControllerBase from './base';
import { NewValuesTooltipOrdersPhase } from './new_values/tooltip_orders_phase';
export default class ScheduleController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_OVER_ORDERS_PHASE, (e) => { this.onOverOrdersPhase(e) })
    this.customEvent(PLANNER_OUT_ORDERS_PHASE,  (e) => { this.onOutOrdersPhase(e) })
    this.customEvent(PLANNER_CLICK_UNDER,       (e) => { this.onClickUnder(e) })
    this.customEvent(PLANNER_CLICK_STATUS,      (e) => { this.onClickStatus(e) })
    this.customEvent(PLANNER_CLICK_PIN,         (e) => { this.onClickPin(e) })
  }
  // OrdersPhaseがマウスオーバーされた
  onOverOrdersPhase(e){
    let overOrdersPhase:LineOverOrdersPhase = e.detail
    let newVal = {
      orders_planner: {
        overOrdersPhase: overOrdersPhase
      }
    };
    NewValuesTooltipOrdersPhase.set(newVal, overOrdersPhase);
    let event = new CustomEvent(PLANNER_SHOW_ORDERS_PHASE_TT, {detail: newVal})
    document.dispatchEvent(event);
  }
  // OrdersPhaseがマウスアウトされた
  onOutOrdersPhase(e){
    let event = new CustomEvent(PLANNER_HIDE_ORDERS_PHASE_TT)
    document.dispatchEvent(event);
  }
  onClickUnder(e){
    let newVal = {
      black_over: {
        show: true
      }
    };
    this.updateData(newVal);
    this.updatePlanner({
      orders_planner: {
        updateUnder: e.detail
      }
    });
  }
  onClickStatus(e){
    let newVal = {
      black_over: {
        show: true
      }
    };
    this.updateData(newVal);
    this.updatePlanner({
      orders_planner: {
        updateStatus: e.detail
      }
    });
  }
  onClickPin(e){
    let orderId = e.detail
    let currentIds = this.data()['forms_planner_search'].inputs.order_ids.value
    if(!currentIds){ currentIds = '' }
    let ary = []
    if(currentIds != ''){
      ary = currentIds.split(',')
    }
    let index = ary.indexOf(orderId.toString())
    if(index >= 0){
      ary.splice(index, 1)
    } else {
      ary.push(orderId)
    }
    let items = []
    for(let i=0;i<ary.length;i++){
      let order_id = ary[i]
      if(order_id == ''){ continue; }
      let orderData = this.getOrderData(order_id)
      items.push({ order_id: order_id, job_no: orderData.job_no })
    }
    let orderIds = ary.join(',')
    let newVal = {
      forms_planner_search: {
        inputs: {
          order_ids: {
            value: orderIds,
            items: items
          }
        }
      }
    }
    this.updateData(newVal);
    let orderNewVal = {}
    if(index < 0){
      orderNewVal["order_" + orderId] = { pined: true }
    }else{
      orderNewVal["order_" + orderId] = { pined: false }
    }
    this.updateOrders(orderNewVal)
  }
}
